import { render, staticRenderFns } from "./MainCertificate.vue?vue&type=template&id=8e91d61c&scoped=true"
import script from "./MainCertificate.vue?vue&type=script&lang=js"
export * from "./MainCertificate.vue?vue&type=script&lang=js"
import style0 from "./MainCertificate.vue?vue&type=style&index=0&id=8e91d61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e91d61c",
  null
  
)

export default component.exports